export default __webpack_public_path__ + "static/media/LogoHCem.fc0e6c81.svg";